import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { SeasonEntityResources, SeasonEntityResponse } from "~types/seasonEntity.ts";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties.ts";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect";

type Props = SelectBaseSingleProperties<InfinitySelectOption>;

export const SelectSeasonEntity = ({ value, ...props }: Props) => {
  const { sport, organizationId, seasonId } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: SeasonEntityResponse) => {
    const resources: SeasonEntityResources | undefined = response?.includes?.resources;
    return (response?.data || []).map((seasonEntity) => {
      const entity = resources?.[seasonEntity?.entity?.resourceType ?? ""]?.[seasonEntity?.entity?.id ?? ""];
      return {
        label: entity?.nameFullLocal ?? seasonEntity.entityId,
        value: seasonEntity.entityId,
      };
    });
  };

  return (
    <InfinitySelect<SeasonEntityResponse>
      {...props}
      url={`${sport}/o/${organizationId}/seasons/${seasonId}/entities`}
      includes={["entities"]}
      searchParameter="entityNameFullLocalContains"
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.SEASON_ENTITY}
      permissionOperation={PermissionOperations.READ}
    />
  );
};
